import {
  EnvelopeIcon,
  EnvelopeOpenIcon,
  MapPinIcon,
  PhoneArrowDownLeftIcon,
  PhoneIcon,
} from "@heroicons/react/20/solid";
import { PhoneArrowUpRightIcon } from "@heroicons/react/24/solid";
import React from "react";
import { Link } from "react-router-dom";

const CustomizeFooter = () => {
  return (
    <div className="mx-auto max-sm grid grid-cols-1 font-poppins md:grid-cols-3 md:max-w-5xl">
      <div className="m-4">
        <div className="mb-6 text-primary text-base font-bold ">
          Our Links:
          <div className="border-dashed border-2 w-24 border-b-secondary"></div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-1 text-P14 font-normal textgray">
          <Link
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            Home
          </Link>
          <Link
            to="/about"
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            About Zulal
          </Link>
          <Link
            to="/productsrange"
            onClick={() => {
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            Zulal Store
          </Link>
          <Link
            to="/NewsMedia"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            News & Media
          </Link>
          <Link
            to="/ContactUs"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            Contact Us
          </Link>
          <Link
            to="/user/complaintpage"
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            state={{
              PageTitle: "Suggestion & Complaints",
              fromPage: "complaint",
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            Suggestion / Complaints
          </Link>

          <Link
            to={"/refundpolicy"}
            onClick={() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
            state={{
              PageTitle: "Refund Policy",
              fromPage: "refund",
            }}
            className="text-sm font-semibold leading-6 hover:text-textgray dark:hover:text-secondaryHover"
          >
            Refund Policy
          </Link>
        </div>
      </div>
      <div className="m-4">
        <div className="mb-6 text-primary text-base font-bold ">
          Get in Touch:
          <div className="border-dashed border-2 w-24 border-b-secondary"></div>
        </div>
        <div className="flex flex-col text-base font-normal textgray font-poppins gap-2">
          <div className="flex flex-row gap-2">
            <MapPinIcon className="text-primary h-7" />
            <span className="textgray text-P14 font-poppins font-normal w-auto md:w-40">
              Al Rahmaniya, Sharjah, U.A.E. P.O. Box: 79979
            </span>
          </div>
          <div className="flex flex-row gap-4">
            <EnvelopeIcon className="text-primary h-6" />
            <span className="textgray text-P14 font-poppins font-normal">
              <a
                className="hover:text-cool-gray-600"
                href="mailto:help@zulal.ae"
              >
                help@zulal.ae
              </a>
            </span>
          </div>
          <div className="flex flex-row gap-4">
            <PhoneArrowUpRightIcon className="text-primary h-6" />
            <span className="textgray text-P14 font-poppins font-normal">
              600 55 6666
            </span>
          </div>

          <div className="flex flex-row gap-2 mt-4">
            <Link hidden to="#">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 29.9996C11.0218 29.9996 7.20647 28.4192 4.39342 25.6062C1.58036 22.7932 0 18.978 0 14.9998C0 11.0216 1.58036 7.20634 4.39342 4.39334C7.20647 1.58033 11.0218 0 15 0C18.9783 0 22.7936 1.58033 25.6067 4.39334C28.4197 7.20634 30.0001 11.0216 30.0001 14.9998C30.0001 18.978 28.4197 22.7932 25.6067 25.6062C22.7936 28.4192 18.9783 29.9996 15 29.9996Z"
                  fill="#29A9E1"
                />
                <path
                  d="M7.00781 20.0211C8.44774 20.9435 10.1136 21.4524 11.8232 21.4919C13.5328 21.5315 15.2204 21.1003 16.7014 20.2454C18.1825 19.3906 19.4 18.145 20.2209 16.6449C21.0418 15.1447 21.4344 13.4478 21.3559 11.7395C21.9977 11.2764 22.5517 10.7024 22.9918 10.0447C22.3934 10.3097 21.7586 10.4836 21.1087 10.5608C21.7938 10.1514 22.3063 9.50645 22.5505 8.74662C21.9061 9.12855 21.2011 9.39764 20.4661 9.54229C19.9718 9.01605 19.3177 8.66749 18.6053 8.55062C17.8928 8.43374 17.1616 8.55507 16.5251 8.8958C15.8886 9.23654 15.3822 9.77767 15.0843 10.4354C14.7865 11.0931 14.7138 11.8306 14.8776 12.5338C13.5741 12.4681 12.299 12.1291 11.135 11.5387C9.97097 10.9483 8.94416 10.1197 8.12119 9.10672C7.70184 9.82879 7.57336 10.6835 7.7619 11.497C7.95044 12.3104 8.44184 13.0214 9.13609 13.4854C8.61499 13.4691 8.10533 13.3283 7.64967 13.075C7.64045 13.8393 7.89817 14.5828 8.3784 15.1774C8.85863 15.7721 9.53127 16.1805 10.2804 16.3324C9.7975 16.4634 9.29111 16.4826 8.79971 16.3885C9.00901 17.04 9.41678 17.6098 9.96595 18.0181C10.5151 18.4263 11.1782 18.6527 11.8624 18.6655C10.4878 19.7429 8.74172 20.2305 7.00781 20.0211Z"
                  fill="white"
                />
              </svg>
            </Link>
            <Link to="https://instagram.com/zulal.shj" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
              >
                <path
                  d="M15 29.9996C11.0218 29.9996 7.20647 28.4192 4.39341 25.6062C1.58036 22.7932 0 18.978 0 14.9998C0 11.0216 1.58036 7.20634 4.39341 4.39334C7.20647 1.58033 11.0218 0 15 0C18.9783 0 22.7936 1.58033 25.6067 4.39334C28.4197 7.20634 30.0001 11.0216 30.0001 14.9998C30.0001 18.978 28.4197 22.7932 25.6067 25.6062C22.7936 28.4192 18.9783 29.9996 15 29.9996Z"
                  fill="url(#paint0_radial_1068_6718)"
                />
                <path
                  d="M14.9996 8.25845C17.1961 8.25845 17.4556 8.26707 18.3232 8.30589C18.8448 8.31217 19.3615 8.40821 19.8506 8.5898C20.2053 8.72645 20.5275 8.9359 20.7964 9.20466C21.0653 9.47342 21.2749 9.79552 21.4117 10.1502C21.5928 10.6394 21.6886 11.156 21.6949 11.6776C21.7345 12.5444 21.7431 12.8046 21.7431 15.0011C21.7431 17.1977 21.7345 17.4571 21.6949 18.3239C21.6886 18.8455 21.5928 19.3621 21.4117 19.8513C21.2749 20.2061 21.0653 20.5283 20.7964 20.7971C20.5275 21.066 20.2053 21.2756 19.8506 21.4125C19.3614 21.5937 18.8448 21.6895 18.3232 21.6957C17.4556 21.7352 17.1961 21.7431 14.9996 21.7431C12.803 21.7431 12.5428 21.7345 11.676 21.6957C11.1544 21.6895 10.6377 21.5937 10.1486 21.4125C9.79382 21.2756 9.47164 21.066 9.20276 20.7971C8.93388 20.5283 8.72426 20.2061 8.58741 19.8513C8.40606 19.3622 8.31003 18.8456 8.3035 18.3239C8.26397 17.4571 8.25606 17.1969 8.25606 15.0011C8.25606 12.8053 8.26469 12.5444 8.3035 11.6776C8.31003 11.156 8.40606 10.6393 8.58741 10.1502C8.72423 9.79552 8.93384 9.47342 9.20273 9.20466C9.47161 8.9359 9.79383 8.72645 10.1486 8.5898C10.6377 8.40821 11.1543 8.31217 11.676 8.30589C12.5428 8.26635 12.8037 8.25845 14.9996 8.25845ZM14.9996 6.77637C12.7656 6.77637 12.4839 6.78571 11.6084 6.82596C10.9262 6.83962 10.2513 6.96892 9.61239 7.20834C9.06598 7.41957 8.56977 7.74269 8.1556 8.15698C7.74142 8.57127 7.41844 9.06757 7.20738 9.61403C6.96775 10.2529 6.83844 10.9278 6.82499 11.61C6.78473 12.4876 6.77539 12.7672 6.77539 15.0011C6.77539 17.235 6.78473 17.5168 6.82499 18.3922C6.83844 19.0744 6.96775 19.7494 7.20738 20.3882C7.41844 20.9347 7.74142 21.431 8.1556 21.8453C8.56977 22.2596 9.06598 22.5827 9.61239 22.7939C10.2513 23.0333 10.9262 23.1626 11.6084 23.1763C12.486 23.2165 12.7656 23.2259 14.9996 23.2259C17.2335 23.2259 17.5153 23.2165 18.3907 23.1763C19.0729 23.1627 19.7479 23.0334 20.3868 22.7939C20.9331 22.5825 21.4294 22.2593 21.8436 21.8451C22.2579 21.4308 22.5811 20.9346 22.7925 20.3882C23.0315 19.7492 23.1608 19.0744 23.1749 18.3922C23.2144 17.5153 23.2245 17.235 23.2245 15.0011C23.2245 12.7672 23.2151 12.4855 23.1749 11.61C23.1608 10.9279 23.0315 10.2531 22.7925 9.61403C22.5811 9.06766 22.2579 8.57146 21.8436 8.1572C21.4294 7.74294 20.9331 7.41976 20.3868 7.20834C19.7479 6.96887 19.0729 6.83957 18.3907 6.82596C17.5138 6.78571 17.2335 6.77637 14.9996 6.77637Z"
                  fill="white"
                />
                <path
                  d="M14.9989 10.7778C14.1636 10.7778 13.347 11.0255 12.6524 11.4896C11.9579 11.9537 11.4166 12.6133 11.0969 13.385C10.7772 14.1568 10.6936 15.0059 10.8565 15.8252C11.0195 16.6445 11.4218 17.397 12.0124 17.9877C12.6031 18.5783 13.3557 18.9806 14.1749 19.1435C14.9942 19.3065 15.8434 19.2229 16.6152 18.9032C17.3869 18.5835 18.0465 18.0422 18.5106 17.3477C18.9747 16.6531 19.2224 15.8366 19.2224 15.0013C19.2224 13.8811 18.7774 12.8069 17.9854 12.0148C17.1933 11.2228 16.119 10.7778 14.9989 10.7778ZM14.9989 17.7426C14.4567 17.7426 13.9267 17.5818 13.4759 17.2806C13.025 16.9794 12.6737 16.5512 12.4662 16.0503C12.2587 15.5494 12.2044 14.9982 12.3102 14.4665C12.416 13.9347 12.677 13.4462 13.0604 13.0628C13.4438 12.6794 13.9323 12.4184 14.4641 12.3126C14.9959 12.2068 15.5471 12.2611 16.048 12.4686C16.5489 12.6761 16.9771 13.0274 17.2783 13.4783C17.5795 13.9291 17.7403 14.4591 17.7403 15.0013C17.7403 15.7283 17.4515 16.4256 16.9374 16.9397C16.4232 17.4538 15.726 17.7426 14.9989 17.7426Z"
                  fill="white"
                />
                <path
                  d="M20.3761 10.608C20.3761 10.8031 20.3182 10.9939 20.2098 11.1562C20.1013 11.3185 19.9472 11.445 19.7669 11.5197C19.5865 11.5944 19.3881 11.6139 19.1967 11.5758C19.0052 11.5378 18.8294 11.4438 18.6914 11.3058C18.5534 11.1677 18.4594 10.9919 18.4213 10.8005C18.3832 10.609 18.4028 10.4106 18.4775 10.2303C18.5522 10.05 18.6786 9.89585 18.8409 9.78741C19.0032 9.67897 19.194 9.62109 19.3892 9.62109C19.651 9.62109 19.902 9.72507 20.087 9.91014C20.2721 10.0952 20.3761 10.3462 20.3761 10.608Z"
                  fill="white"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_1068_6718"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(-0.750003 30.0896) scale(55.4702 55.4692)"
                  >
                    <stop stopColor="#F5EC53" />
                    <stop offset="0.241" stopColor="#E48244" />
                    <stop offset="0.397" stopColor="#D05667" />
                    <stop offset="0.489" stopColor="#C84278" />
                    <stop offset="1" stopColor="#192CFA" />
                  </radialGradient>
                </defs>
              </svg>
            </Link>

            <Link hidden to="https://facebook.com/zulal.shj" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
              >
                <path
                  d="M15.0001 29.9996C11.0218 29.9996 7.20647 28.4192 4.39342 25.6062C1.58036 22.7932 0 18.978 0 14.9998C0 11.0216 1.58036 7.20634 4.39342 4.39334C7.20647 1.58033 11.0218 0 15.0001 0C18.9781 0.00038123 22.793 1.58088 25.6058 4.39384C28.4185 7.20681 29.9986 11.0218 29.9986 14.9998C29.9986 18.9777 28.4185 22.7928 25.6058 25.6057C22.793 28.4187 18.9781 29.9992 15.0001 29.9996Z"
                  fill="#C3271A"
                />
                <path
                  d="M25.6182 9.63015C25.493 9.15856 25.2462 8.72814 24.9023 8.38199C24.5584 8.03585 24.1296 7.78614 23.6588 7.65788C21.9295 7.19141 14.9976 7.19141 14.9976 7.19141C14.9976 7.19141 8.06581 7.19141 6.33716 7.65788C5.86633 7.78616 5.43745 8.03587 5.09346 8.382C4.74947 8.72813 4.50244 9.15854 4.37708 9.63015C3.75972 13.1837 3.75972 16.817 4.37708 20.3706C4.50212 20.8429 4.74917 21.274 5.09346 21.6207C5.43775 21.9674 5.86715 22.2174 6.33859 22.3457C8.06724 22.8122 14.9991 22.8122 14.9991 22.8122C14.9991 22.8122 21.9309 22.8122 23.6603 22.3457C24.131 22.2175 24.5598 21.9678 24.9037 21.6216C25.2476 21.2755 25.4945 20.845 25.6196 20.3734C26.2376 16.82 26.2376 13.1865 25.6196 9.63303L25.6182 9.63015Z"
                  fill="white"
                />
                <path
                  d="M12.7305 18.2968V11.7051L18.5245 15.0013L12.7305 18.2968Z"
                  fill="#C3271A"
                />
              </svg>
            </Link>
            <Link to="https://facebook.com/zulal.shj" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
              >
                <path
                  d="M15 29.9996C11.0218 29.9994 7.20664 28.419 4.39362 25.606C1.58061 22.7931 0.000190614 18.9779 0 14.9998C0 11.0216 1.58036 7.20634 4.39341 4.39334C7.20647 1.58033 11.0218 0 15 0C18.9783 0 22.7936 1.58033 25.6067 4.39334C28.4197 7.20634 30.0001 11.0216 30.0001 14.9998C30.0001 18.978 28.4197 22.7932 25.6067 25.6062C22.7936 28.4192 18.9783 29.9996 15 29.9996Z"
                  fill="#3E5C9A"
                />
                <path
                  d="M12.7154 24.0672H16.3653V14.9231H18.9126L19.1843 11.8612H16.3653V10.1175C16.3653 9.39873 16.5091 9.11123 17.2084 9.11123H19.1843V5.93359H16.6579C13.9409 5.93359 12.7161 7.13033 12.7161 9.4203V11.8641H10.8164V14.9641H12.7154V24.0672Z"
                  fill="white"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <div className="m-4">
        <div className="mb-6 text-primary text-base font-bold ">
          Download Zulal App
          <div className="border-dashed border-2 w-24 border-b-secondary"></div>
        </div>
        <div className="flex flex-col text-base font-normal textgray font-poppins gap-2">
          <div className="flex flex-row gap-2">
            <a
              href="https://apps.apple.com/us/app/zulal-water/id6477540008"
              target="_blank"
            >
              <img
                src="../../images/appStore.png"
                alt="Zulal Mobile App"
                className="w-44"
              />
            </a>
          </div>
          <div className="flex flex-row gap-4">
            <a
              href="https://play.google.com/store/apps/details?id=com.incube.zulal"
              target="_blank"
            >
              <img
                src="../../images/googleplay.png"
                alt="Zulal Mobile App"
                className="w-44"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="m-4">
        <div className="mb-6 text-primary text-base font-bold  ">
          Location Map:
          <div className="border-dashed border-2 w-24 border-b-secondary"></div>
        </div>
        <div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.7386528757015!2d55.579552676056935!3d25.31298332699997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5a4e0d66382f%3A0x99000591387404d1!2sZulal!5e0!3m2!1sen!2sae!4v1705517056855!5m2!1sen!2sae"
            width="352px"
            height="350px"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default CustomizeFooter;
